import * as constants from './constants';
import {
  fromJS
} from 'immutable';
const defaultState =  fromJS({
    subjectInfo: [],
    attachmentList:[],
    grade_tpl:{},
    grade_tpl_content:{},
    lab:{},
    score:'', 
    mySubRecord:[],
    recordContent:{
        report:{},
        attach:[]
    },
    recordAll:[]
})

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CHANGE_SUBJECT_INFO:
            return state.merge({
               subjectInfo:action.subjectInfo
            });
        case constants.CHANGE_ATTACHMENT_LIST:
            return state.merge({
                attachmentList:action.attachmentList
            });
        case constants.CHANGE_LAB_CONTENT:
            return state.merge({
                lab:action.lab
            });
        case constants.CHANGE_GRADE_TPL:
            return state.merge({
                grade_tpl:action.grade_tpl,
                grade_tpl_content:action.grade_tpl_content
            })
        case constants.CHANGE_MY_SUB_RECORD:
            return state.merge({
                mySubRecord:action.mySubRecord,
            })
        case constants.CHANGE_MY_SCORE:
            return state.merge({
                score:action.score,
            })
        case constants.CHANGE_MY_RECORD_CONTENT:
            return state.merge({
                recordContent:action.recordContent,
                recordAll:action.recordAll
            })
        case constants.CHANGE_RECORD_ALL:
            return state.merge({ 
                recordAll:action.recordAll
            })
        default:
            return state;
    }
}
 